module.exports = __webpack_public_path__ + "img/phone_green_icon.c58cdab7.svg";